import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-6 bg-white shadow-sm rounded-2xl mb-10"
}
const _hoisted_3 = { class: "flex items-center justify-between mb-6" }
const _hoisted_4 = { class: "font-semibold text-neutral-600 w-1/2" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold text-neutral-600 text-right lg:mr-8 w-fit"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z",
    fill: "#94A3B8",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z",
    fill: "#94A3B8",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mt-0.5" }, "Tạo nhóm mới", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.9759 2.73814L9.31765 15.7438C9.26208 15.8975 9.1162 15.9999 8.95276 16H8.82854C8.67608 16 8.53718 15.9124 8.47141 15.7748L6.63918 11.8926C6.36938 11.3202 6.4738 10.6414 6.90314 10.1766L9.23225 7.62981C9.3752 7.47984 9.3752 7.24403 9.23225 7.09406L8.93723 6.799C8.78728 6.65604 8.55149 6.65604 8.40154 6.799L5.85504 9.12837C5.39031 9.55775 4.71155 9.66219 4.13926 9.39236L0.257408 7.55993C0.107709 7.50356 0.00662856 7.36264 0.00120576 7.20276V7.07853C-0.0125429 6.90383 0.0924328 6.74158 0.257408 6.68254L13.2616 2.0238C13.4014 1.97246 13.5583 2.00564 13.6653 2.10921L13.8672 2.31109C13.9885 2.41709 14.0318 2.58703 13.9759 2.73814Z",
    fill: "#94A3B8"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mt-0.5" }, "Gửi tới phụ huynh", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M12.4705 6.65175L13.7105 5.41172C13.8463 5.27586 13.9143 5.20793 13.9669 5.14597C14.6011 4.39929 14.6011 3.30311 13.9669 2.55644C13.9143 2.49448 13.8463 2.42655 13.7105 2.29069C13.5746 2.15482 13.5067 2.08689 13.4447 2.03426C12.6981 1.40004 11.6019 1.40004 10.8552 2.03426C10.7933 2.08688 10.7253 2.15479 10.5895 2.29059L10.5895 2.29067L10.5894 2.29069L9.33123 3.5489C10.0749 4.84309 11.1586 5.91837 12.4705 6.65175ZM7.87657 5.00356L2.86297 10.0172C2.43791 10.4422 2.22538 10.6547 2.08565 10.9158C1.94591 11.1769 1.88697 11.4717 1.76908 12.0611L1.37342 14.0394C1.3069 14.372 1.27364 14.5383 1.36825 14.6329C1.46286 14.7275 1.62916 14.6943 1.96177 14.6277L3.94005 14.2321L3.94007 14.2321L3.94009 14.2321C4.52951 14.1142 4.82423 14.0553 5.08532 13.9155C5.34641 13.7758 5.55894 13.5633 5.98398 13.1382L5.984 13.1382L5.98401 13.1382L11.012 8.11019C9.75135 7.31198 8.68226 6.25011 7.87657 5.00356Z",
    fill: "#94A3B8",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mt-0.5" }, "Chỉnh sửa", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6" }
const _hoisted_19 = { class: "p-6 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_20 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_0,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_23 = { class: "p-6 border border-neutral-200 w-full md:border-l-0 md-down:border-t-0" }
const _hoisted_24 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_27 = { class: "p-6 border border-neutral-200 w-full md:rounded-tr-lg lg:rounded-tr-none md:border-l-0 md-down:border-t-0" }
const _hoisted_28 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu lặp lại")
], -1)
const _hoisted_31 = { class: "p-6 border border-neutral-200 w-full lg:border-l-0 lg-down:border-t-0 md:rounded-bl-lg lg:rounded-bl-none" }
const _hoisted_32 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu mới")
], -1)
const _hoisted_35 = { class: "p-6 border border-neutral-200 w-full md:border-l-0 lg-down:border-t-0" }
const _hoisted_36 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ MT tạm dừng")
], -1)
const _hoisted_39 = { class: "p-6 border md:border-l-0 lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full lg-down:border-t-0 md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_40 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ Ngân hàng MT")
], -1)
const _hoisted_43 = { class: "mt-4 flex justify-end items-center text-gray-700" }
const _hoisted_44 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_45 = { class: "flex items-center" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_48 = { class: "ml-4 text-blue-600 font-semibold" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 2,
  class: "text-center text-neutral-500 p-6 text-lg"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = {
  key: 3,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "250",
  src: _imports_2,
  width: "250"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Học sinh chưa có Kế hoạch hiện tại. Kế hoạch hiện tại là kế hoạch được dạy và có thể báo cáo kết quả học của các mục tiêu trên app. ", -1)
const _hoisted_58 = { class: "mt-8" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 whitespace-nowrap" }, "Lên kế hoạch", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmSendReportTarget = _resolveComponent("ConfirmSendReportTarget")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GroupDetail = _resolveComponent("GroupDetail")!
  const _component_GoalList = _resolveComponent("GoalList")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.type.CREATE)
          ? (_openBlock(), _createBlock(_component_ConfirmSendReportTarget, {
              key: 0,
              name: _ctx.reportName,
              onClose: _ctx.cancel,
              onSubmit: _ctx.sendNotification
            }, null, 8, ["name", "onClose", "onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.report?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, " Kế hoạch " + _toDisplayString(_ctx.report?.order), 1),
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.report?.applied_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Áp dụng: " + _toDisplayString(_ctx.$filters.formatDate(_ctx.report?.applied_at)), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "ml-3 relative"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, { class: "rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-200",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100" }, {
                                default: _withCtx(() => [
                                  (_ctx.report)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (
											_ctx.$router.push(
												`/create-group-class/${_ctx.report.id}?group_class=${_ctx.id}`
											)
										))
                                      }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass([active ? '' : '', "p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"])
                                          }, _hoisted_11, 2)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.report && !_ctx.report.sent_at)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: 1,
                                        onClick: _ctx.confirmSendOpen
                                      }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass([active ? '' : '', "p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"])
                                          }, _hoisted_14, 2)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (
											_ctx.report?.id &&
											_ctx.report?.state !== 'draft' &&
											_ctx.report?.state !== 'completed'
										)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: 2,
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (
											_ctx.$router.push(
												`/group-class-plans/${_ctx.id}/create?plan_id=${_ctx.report?.id}`
											)
										))
                                      }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass([active ? '' : '', "p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"])
                                          }, _hoisted_17, 2)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.skills_count || '0'), 1)
                    ]),
                    _hoisted_22
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_count || '0'), 1)
                    ]),
                    _hoisted_26
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.continued_goals_count || '0'), 1)
                    ]),
                    _hoisted_30
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.new_goals_count || '0'), 1)
                    ]),
                    _hoisted_34
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_from_stopped_count || '0'), 1)
                    ]),
                    _hoisted_38
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_from_lib_count || '0'), 1)
                    ]),
                    _hoisted_42
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  (_ctx.report && _ctx.report.sent_at && _ctx.report.sent_by_staff)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_router_link, {
                          to: `/record/employee/${_ctx.report.sent_by_staff?.id}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", null, [
                                (
										_ctx.report.sent_by_staff?.profile_photo
											?.w200
									)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: 
										_ctx.report.sent_by_staff?.profile_photo
											?.w200
									,
                                      alt: "",
                                      class: "shadow-sm inline-block h-6 w-6 rounded-full"
                                    }, null, 8, _hoisted_46))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      style: _normalizeStyle({
										background:
											_ctx.report.sent_by_staff?.profile_photo
												?.default?.color,
									}),
                                      class: "inline-flex items-center justify-center h-6 w-6 rounded-full"
                                    }, [
                                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.report.sent_by_staff?.profile_photo
												?.default?.initial), 1)
                                    ], 4))
                              ]),
                              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.report.sent_by_staff.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createTextVNode(" đã gửi KH tới PH "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatDateTime(_ctx.report.sent_at)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_49))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.groups && _ctx.groups.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                (_ctx.groups.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.id,
                          class: "mb-8"
                        }, [
                          _createVNode(_component_GroupDetail, {
                            data: group,
                            index: 
							Number(index) !== Number(_ctx.groups.length - 1)
								? `${index}`
								: ''
						,
                            "is-group-class": true,
                            onRefresh: _ctx.listGroup
                          }, null, 8, ["data", "index", "onRefresh"])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups?.[0]?.goals_group_by_skill, (group, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.id
                        }, [
                          _createVNode(_component_GoalList, {
                            data: group,
                            index: Number(index),
                            "is-group": true,
                            "student-id": Number(_ctx.id),
                            class: "mb-6",
                            "key-goals": "group_goals",
                            future: false
                          }, null, 8, ["data", "index", "student-id"])
                        ]))
                      }), 128))
                    ]))
              ]))
            : (_ctx.report?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createTextVNode(" Kế hoạch hiện tại chưa có mục tiêu. "),
                  _hoisted_54,
                  _createTextVNode(" Bạn hãy chọn Chỉnh sửa kế hoạch để thêm mục tiêu cho lớp nhóm. ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _hoisted_56,
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("button", {
                      class: "button-p btn--ghost w-fit",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
						_ctx.$router.push(
							`/group-class-plans/${_ctx.id}/create?plan_id=${_ctx.id}`
						)
					))
                    }, _hoisted_60)
                  ])
                ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createVNode(_component_Loading)
        ]))
  ], 64))
}